import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '../../../models';

export interface RebuildStatus {
  status: 'idle' | 'in_progress' | 'completed' | 'failed';
  message?: string;
  started_at?: string;
  completed_at?: string;
  result?: {
    totalVariants: number;
    indexed: number;
    skipped: number;
    errors: number;
    categories: boolean;
    brands: boolean;
  };
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SearchIndexService {
  private readonly apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string
  ) {
    this.apiUrl = `${apiUrl}/api/${apiVersion}/product-variant`;
  }

  triggerRebuild(force = false): Observable<any> {
    const url = `${this.apiUrl}/rebuild-search-index${force ? '?force=true' : ''}`;
    return this.httpClient
      .get<ApiResponse<any>>(url)
      .pipe(map((x) => x));
  }

  getStatus(): Observable<RebuildStatus> {
    return this.httpClient
      .get<ApiResponse<RebuildStatus>>(`${this.apiUrl}/rebuild-search-index/status`)
      .pipe(map((x) => x.data as RebuildStatus));
  }

  clearCache(): Observable<any> {
    return this.httpClient
      .post<ApiResponse<any>>(`${this.apiUrl}/clear-cache`, {})
      .pipe(map((x) => x));
  }
}
